(ns frontend.view.onboarding.initialize-account.view
  (:require
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [frontend.bootstrap.components :as rbs]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.view.onboarding.components.common :as common]
   [frontend.view.onboarding.initialize-account.db :as db]
   [frontend.view.onboarding.initialize-account.events :as events]
   [ui.components.button.view :as button]))

(def team-role-options
  [:team-role/option-1
   :team-role/option-2
   :team-role/other])

(def responsibility-options
  [:responsibility/option-1
   :responsibility/option-2])

(defn radio-selector
  [{:keys [label control-id value values change!] :as _view-args}]
  [:div.onboarding__select.mb-3
   [:div
    [:div
     [:div.onboarding__select-label
      label]]]
   [:div
    {:class-name "zap-form__light-grey__green__sand form-group mb-0"}
    [:div.onboarding__select-options
     (doall
      (for [v values]
        ^{:key (str control-id "-radio-" v)}
        [:div.radio
         [:label
          {:class-name "zap-inlined-radiobox-label"}
          [:input
           {:type       "radio"
            :class-name "zap-inlined-radiobox__green"
            :checked    (= value v)
            :on-change  (partial change! v)}]
          [:span {:class-name "radiomark"}]
          (let [fs (registry/get-field-schema @session/tenant-schema v)]
            (loc/field-name v fs))]]))]]])

(defn multi-selector
  [{:keys [label control-id value values change!] :as _view-args}]
  [:div.onboarding__select
   [:div
    {:class "px-4"}
    [:div
     [:div.onboarding__select-label
      label
      [:div.onboarding__select-info.text-secondary
       (loc/tr :select-all-that-apply)]]]]
   [:div
    {:class-name "zap-form__light-grey__green__sand form-group mb-0"}
    [:div.onboarding__multiselect-options
     (doall
      (for [v values]
        ^{:key (str control-id "-checkbox-" v)}
        [:div.checkbox
         [:label
          {:class-name "zap-inlined-checkbox-label"}
          [:input
           {:type       "checkbox"
            :class-name "zap-inlined-checkbox__green"
            :checked    (contains? value v)
            :on-change  (partial change! v)}]
          [:span {:class-name "checkmark"}]
          [:span.checkbox-label
           (let [fs (registry/get-field-schema @session/tenant-schema v)]
             (loc/field-name v fs))]]]))]]])

(defn view
  []
  (let [{:keys [team-role additional-responsibilities]} @db/state]
    [:div
     {:class-name "container onboarding lose-padding-small"}
     [:div
      {:class-name "onboarding-row"}

      [:div
       {:class-name "px-4 onboarding-inner onboarding__account-initialization"}
       [common/logo]
       [:div.card.md
        [:h2 (loc/tr :email-welcome-subject-zadmin)]
        [:div.onboarding__info.mb-3.text-secondary [:span (loc/tr :onboarding/page4-info)]]
        [:div
         {:class-name "onboarding-row-team-role"}
         [:div
          [radio-selector
           {:value      team-role
            :label      (loc/tr :onboarding/team-role)
            :control-id "team-role-selection"
            :values     team-role-options
            :change!    (partial events/update! :team-role)}]]]
        [:div
         [:div
          {:class-name "onboarding__avatars-row"}
          [multi-selector
           {:value      additional-responsibilities
            :label      (loc/tr :onboarding/additional-responsibilities)
            :control-id "responsibilities-selection"
            :values     responsibility-options
            :change!    (partial events/update-multi! :additional-responsibilities)}]]]

         [:div
          {:class "my-3 flex justify-center gap-3"}
         [button/primary-solid
          {:on-click  events/initialize-account!
           :disabled? (nil? team-role)}
          (loc/tr :proceed)]]]]]]))

(defmethod routing/render-view :initialize-account
  []
  [view])
